import propTypes from 'prop-types';

import Button from '../Button';
import Text from '../Text';
import Flex from '../Flex';
import { Container } from './styles';

function Alert({
  background,
  icon: Icon,
  text,
  secondaryText,
  buttonText,
  buttonAction,
  fixed,
  ...props
}) {
  return (
    <Container
      justifyContent="space-between"
      alignItems="center"
      bg={background}
      fixed={fixed}
      px={16}
      py={16}
      mb={16}
      {...props}
    >
      <Flex flex={1} justifyContent="center" alignItems="center">
        <Icon />

        <Flex
          ml={12}
          flex={1}
          flexDirection="column"
          gridGap="8px"
          justifyContent="center"
          alignItems="flex-start"
        >
          <Text
            color="white"
            fontSize="14px"
            fontWeight="600"
            lineHeight="16px"
          >
            {text}
          </Text>
          {secondaryText && (
            <Text
              color="white"
              fontSize="12px"
              fontWeight="400"
              lineHeight="14px"
            >
              {secondaryText}
            </Text>
          )}
        </Flex>
      </Flex>
      {buttonAction && buttonText && (
        <Button onClick={buttonAction}>{buttonText}</Button>
      )}
    </Container>
  );
}

export default Alert;

Alert.propTypes = {
  background: propTypes.string.isRequired,
  icon: propTypes.any.isRequired,
  text: propTypes.string.isRequired,
  secondaryText: propTypes.string,
  buttonText: propTypes.string,
  buttonAction: propTypes.func,
  fixed: propTypes.bool,
};

Alert.defaultProps = {
  secondaryText: '',
  buttonText: '',
  buttonAction: '',
  fixed: false,
};
